import React from "react";
import { motion } from "framer-motion";
import ProjectCard from "./ProjectCard";
import { UPCOMING_PROJECTS, PROJECTS } from "../data/projects";

export default function UpcomingProject() {
  const project = UPCOMING_PROJECTS[0];

  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="bg-white border-t border-black/10 py-24 md:py-40 lg:py-48"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1 }}
          className="flex items-baseline justify-between mb-16 md:mb-24"
        >
          <span className="label">Upcoming Project</span>
          <span className="label hidden sm:inline" data-testid="upcoming-project-number">
            N° {project.number} / {String(PROJECTS.length).padStart(2, "0")}
          </span>
        </motion.div>

        <ProjectCard project={project} testIdPrefix="project" />
      </div>
    </section>
  );
}
